import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import web5 from "../img/hr.jpg";
import web1 from "../img/wlt.jpg";

import "../style/styles.css";
import "../style/PaySof.css";

const PaySof = () => {
  let alText = "Photo";

  const quickStats = [
    { value: "HR", label: "Payroll Solution" },
    { value: "Bio", label: "Biometric Attendance" },
    { value: "Face", label: "Facial Attendance" },
    { value: "MIS", label: "Reports HUB" },
  ];

  const keyModules = [
    {
      title: "Key features(Entry Module)",
      text:
        "Department Entry, Designation Entry, Employee Entry, Salary Configuration, Daily, Weekly, Monthly Shifting and Shifting Allotment.",
    },
    {
      title: "Accounting Reports",
      text:
        "Staff Attendance with finger print, card swipe & password, Daily Biometric Attendance, Facial Attendance, Employee Advance, Employee LIC, Insurance and Leave Confirguration.",
    },
    {
      title: "Reports HUB",
      text:
        "Employee Wise Attendance Register, Employee Wise Attendance Summary, Payslip Printing, Salary Register, PF Statement, FPF Statement, Income Tax Statement and Professional Tax Statement.",
    },
    {
      title: "Biometric Attendance",
      text:
        "PayHR is a complete payroll management system with biometric attendance system for HR Department operations.",
    },
    {
      title: "Multi Branching",
      text:
        "Web application with multi branching for payroll and HR solution.",
    },
    {
      title: "Payroll Analysis",
      text:
        "Its advance report utility will allow you to efficiently analyze your business, helping you increase your sales volume and profits.",
    },
  ];

  const entryFeatures = [
    "Department Entry",
    "Designation Entry",
    "Employee Entry",
    "Salary Configuration",
    "Daily,Weekly,Monthly Shifting",
    "Shifting Allotment",
  ];

  const accountingReports = [
    "Staff Attendance with finger print, card swipe & password",
    "Daily Biometric Attendance",
    "Facial Attendance",
    "Employee Advance",
    "Employee LIC ,Insurance",
    "Leave Confirguration",
  ];

  const reportsHub = [
    "Employee Wise Attendance Register",
    "Employee Wise Attendance Summary",
    "Payslip Printing",
    "Salary Register",
    "PF Statement",
    "FPF Statement",
    "Income Tax Statement",
    "Professional Tax Statement",
  ];

  const overviewItems = [
    "Payroll management system",
    "Biometric attendance system",
    "Web application with multi branching",
    "Department Entry",
    "Employee Entry",
    "Salary Configuration",
    "Payslip Printing",
    "Salary Register",
  ];

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="paysof-detail-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          PayHR - Software for Payroll and HR Solution | EBS Software Solution
        </title>
        <meta
          name="description"
          content="PayHR is software for payroll and HR solution with department entry, designation entry, employee entry, salary configuration, daily weekly monthly shifting, biometric attendance, facial attendance, employee advance, LIC, insurance, leave configuration, payslip, salary register, PF, FPF, income tax and professional tax statement."
        />
      </Helmet>

      <section className="paysof-hero">
        <img
          className="paysof-hero-bg"
          src={web5}
          alt={alText}
          onError={handleImageError}
        />
        <div className="paysof-hero-overlay"></div>

        <Container className="paysof-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="paysof-hero-content">
                <div className="paysof-kicker">Payroll and HR Software</div>
                <h1>PayHR</h1>
                <h2>Software for Payroll and HR Solution</h2>
                <p>
                  PayHR is the most trusted, tested and proven software package
                  for the HR Department.It is a complete payroll management
                  system with biometric attendance system. Its advance report
                  utility will allow you to efficiently analyze your business,
                  helping you increase your sales volume and profits.
                </p>

                <div className="paysof-hero-actions">
                  <a href="#paysof-modules" className="paysof-btn paysof-btn-primary">
                    View Features
                  </a>
                  <Link to="/EmailContactForm" className="paysof-btn paysof-btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="paysof-highlight-card">
                <span>Web application with multi branching</span>
                <strong>Payroll + Attendance + Salary + Reports</strong>
                <p>
                  Designed for HR Department payroll, biometric attendance,
                  salary configuration, employee records and statutory reports.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="paysof-stats-section">
        <Container>
          <Row className="g-3">
            {quickStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="paysof-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="paysof-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="paysof-section-label">Overview</div>
              <h2 className="paysof-section-title">
                Trusted payroll and HR management software
              </h2>
              <p className="paysof-text">
                PayHR is the most trusted, tested and proven software package
                for the HR Department. It is a complete payroll management
                system with biometric attendance system.
              </p>
              <p className="paysof-text">
                Its advance report utility will allow you to efficiently analyze
                your business, helping you increase your sales volume and
                profits. It supports web application with multi branching.
              </p>
            </Col>

            <Col lg={6}>
              <div className="paysof-overview-card">
                <h3>PayHR covers</h3>
                <div className="paysof-overview-grid">
                  {overviewItems.map((item) => (
                    <div key={item}>
                      <span>✓</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="paysof-modules-section" id="paysof-modules">
        <Container>
          <div className="paysof-heading-center">
            <div className="paysof-section-label">Key Modules</div>
            <h2 className="paysof-section-title">
              Complete payroll workflow from employee entry to reports
            </h2>
            <p>
              PayHR connects employee setup, salary configuration, shifting,
              biometric attendance, facial attendance, employee advance, leave,
              payslip, salary register and statutory reports in one HR solution.
            </p>
          </div>

          <Row className="g-4">
            {keyModules.map((module, index) => (
              <Col lg={4} md={6} key={module.title}>
                <div className="paysof-module-card">
                  <div className="paysof-module-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="paysof-feature-list-section">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="paysof-list-card">
                <div className="paysof-section-label">Entry Module</div>
                <h2>Key features(Entry Module)</h2>
                <ul>
                  {entryFeatures.map((item) => (
                    <li key={item}>
                      <span>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="paysof-list-card paysof-list-card-dark">
                <div className="paysof-section-label">Accounting Reports</div>
                <h2>Accounting Reports</h2>
                <ul>
                  {accountingReports.map((item) => (
                    <li key={item}>
                      <span>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="paysof-feature-list-section paysof-feature-list-alt">
        <Container>
          <Row className="g-4">
            <Col lg={7}>
              <div className="paysof-list-card">
                <div className="paysof-section-label">Reports HUB</div>
                <h2>Reports HUB</h2>
                <ul>
                  {reportsHub.map((item) => (
                    <li key={item}>
                      <span>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={5}>
              <div className="paysof-image-card">
                <img
                  src={web1}
                  alt={alText}
                  onError={handleImageError}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="paysof-cta-section">
        <Container>
          <div className="paysof-cta-card">
            <div>
              <span>Ready to manage payroll and HR professionally?</span>
              <h2>Use PayHR for payroll, attendance, salary and reports.</h2>
              <p>
                Get a payroll and HR solution with biometric attendance, facial
                attendance, salary configuration, employee advance, leave,
                payslip, salary register and statutory reports.
              </p>
            </div>
            <Link to="/EmailContactForm" className="paysof-btn paysof-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default PaySof;
